import {create} from 'zustand';
import {DashboardDto} from '../../../../../shared/types/api-v2.types';

interface ChartsDataStore {
  isLoading: boolean;
  contracts: DashboardDto;

  setContracts: (data: DashboardDto) => void;
  setIsLoading: (isLoading: boolean) => void;
}

export const useSecondaryChartsDataStore = create<ChartsDataStore>((set) => ({
  isLoading: false,
  contracts: {},
  setContracts: (contracts) => set({contracts, isLoading: false}),
  setIsLoading: (isLoading) => set({isLoading}),
}));
